module.exports = __webpack_public_path__ + "static/background_video_renewable_lp-b4d43fbcf370aafdc42e1f9dd2d2b5cc.mp4";